import { defineMessages } from 'react-intl';

export default defineMessages({
  relevantSitesDropdownTrigger: {
    id: 'frontbucket.jiraTab.relevantSites.trigger',
    description:
      'Trigger text of drop down menu which contains relevant sites.',
    defaultMessage: 'Site',
  },
  relevantSitesDropdownHeading: {
    id: 'frontbucket.jiraTab.relevantSites.dropdownHeading',
    description:
      'Heading text of drop down menu which contains relevant sites.',
    defaultMessage: 'Jira sites',
  },
});
